import React from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { styled } from '@material-ui/styles';

const IFrameWrapper = styled(Box)(() => ({
  minHeight: '100%'
}));

const CustomerDashboardNotificationsPageRaw = () => {
  return (
    <IFrameWrapper>
      <iframe
        height="100%"
        src={`${process.env.REACT_APP_SCREENHUB_CONTROL_URL}/cms-dashboard/dashboard-notifications`}
        title="customer-dashboard-notifications"
        width="100%"
        style={{ border: 'none' }}
      />
    </IFrameWrapper>
  );
};

export const CustomerDashboardNotificationsPage = withRouter(CustomerDashboardNotificationsPageRaw);
